import React, { useEffect, useState } from "react";
import intelycareLogo from "../../assets/EMP_clients/intelycare.png";
import CaseStudy from "../../Components/EmployersComponents/EMP_clients/CaseStudy";
import Testimonials from "../../Components/EmployersComponents/EMP_clients/Testimonials";
import CompanyForm from "../../Components/EmployersComponents/EMP_clients/CompanyForm";

import Footer from "../../Components/Footer";


/* CLIENT IMAGES */
import clientImage1 from "../../assets/EMP_clients/client_image1.webp";
import clientImage2 from "../../assets/EMP_clients/client_image2.webp";
import clientImage3 from "../../assets/EMP_clients/client_image3.webp";
import clientImage4 from "../../assets/EMP_clients/client_image4.webp";
import clientImage5 from "../../assets/EMP_clients/client_image5.webp";
import clientImage6 from "../../assets/EMP_clients/client_image6.webp";
import clientImage7 from "../../assets/EMP_clients/client_image7.webp";
import clientImage8 from "../../assets/EMP_clients/client_image8.webp";
import clientImage9 from "../../assets/EMP_clients/client_image9.webp";

/* CLIENT LOGOS */
import clientLogo1 from "../../assets/EMP_clients/client_logo1.webp";
import clientLogo2 from "../../assets/EMP_clients/client_logo2.webp";
import clientLogo3 from "../../assets/EMP_clients/client_logo3.webp";
import clientLogo4 from "../../assets/EMP_clients/client_logo4.webp";
import clientLogo5 from "../../assets/EMP_clients/client_logo5.webp";
import clientLogo6 from "../../assets/EMP_clients/client_logo6.webp";
import clientLogo7 from "../../assets/EMP_clients/client_logo1.webp";
import clientLogo8 from "../../assets/EMP_clients/client_logo5.webp";
import clientLogo9 from "../../assets/EMP_clients/client_logo3.webp";



const imageItems = [
  clientImage1,
  clientImage2,
  clientImage3,
  clientImage4,
  clientImage5,
  clientImage6,
  clientImage7,
  clientImage8,
  clientImage9,
];

const logoItems = [
  clientLogo1,
  clientLogo2,
  clientLogo3,
  clientLogo4,
  clientLogo5,
  clientLogo6,
  clientLogo7,
  clientLogo8,
  clientLogo9,
];

export default function EMP_clients() {
  /* START WITH ALL IMAGES */
  const [gridItems, setGridItems] = useState([
    { type: "image", src: clientImage1 },
    { type: "image", src: clientImage2 },
    { type: "image", src: clientImage3 },

    { type: "image", src: clientImage4 },
    { type: "image", src: clientImage5 },
    { type: "image", src: clientImage6 },

    { type: "image", src: clientImage7 },
    { type: "image", src: clientImage8 },
    { type: "image", src: clientImage9 },
  ]);

  /* RANDOM ANIMATION */
  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(
        Math.random() * gridItems.length
      );

      setGridItems((prev) => {
        const updated = [...prev];

        const currentItem = updated[randomIndex];

        /* IMAGE -> LOGO */
        if (currentItem.type === "image") {
          updated[randomIndex] = {
            type: "logo",
            src:
              logoItems[
                Math.floor(
                  Math.random() * logoItems.length
                )
              ],
          };
        }

        /* LOGO -> IMAGE */
        else {
          updated[randomIndex] = {
            type: "image",
            src:
              imageItems[
                Math.floor(
                  Math.random() * imageItems.length
                )
              ],
          };
        }

        return updated;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [gridItems]);

  return (
    <>
    <section
      className="
        w-full
        md:w-full
        min-h-screen

        bg-white

        grid
        grid-cols-1
        lg:grid-cols-2
      "
    >
      {/* LEFT CONTENT */}
      <div
        className="
          flex
          flex-col
          justify-center

          px-6
          sm:px-10
          lg:px-20

          py-16
        "
      >
  <h1
  className="
    text-[#2a0000]

    mt-[80px]

    text-[38px]
    font-sans
    lg:font-0
    sm:text-[56px]
    md:text-[42px]
    lg:text-[56px]

    leading-[1.2]
    lg:leadin-[0.95]
    max-w-[650px]
    md:max-w-full
  "
>
  {/* MOBILE */}
  <span className="block sm:hidden">
    Our clients are
    <br />
    winning with On-
    <br />
    Demand Pay
  </span>

  {/* LAPTOP / TABLET */}
  <span className="hidden sm:block">
    Our clients are winning
    <br className="hidden md:hidden lg:block" />
    with On- <br className="hidden lg:hidden md:block" /> Demand Pay
  </span>
</h1>

        <p
          className="
            mt-8
            lg:mt-6

            text-[17px]
            md:text-[18px]
            md:font-[400]
            md:max-w-[580px]
            lg:text-[18px]
            font-[600]
            lg:font-[500]

            leading-[1.5]

            max-w-[650px]

            text-[#111]
          "
        >
         Leading companies across industries trust DailyPay to boost
<br className="hidden lg:block" />

         retention, increase engagement, and deliver real business results.
        </p>

        <button
          className="
            mt-8
            lg:mt-6

            bg-[#220303]

            text-white

            px-4
            py-2

            lg:px-5
            lg:py-2.5

            w-fit

            text-[18px]
            lg:text-[16px]

            font-bold
          "
        >
          Get Started
        </button>
      </div>

      {/* RIGHT GRID */}
      <div
        className="
          grid
          grid-cols-3

          gap-0

          auto-rows-[200px]

          overflow-hidden

          relative
          -top-[30px]
          lg:top-[40px]

          lg:ml-[80px]
          md:ml-0

          lg:max-w-[700px]

          lg:pb-[40px]

        "
      >
        {gridItems.map((item, index) => (
          <div
            key={index}
            className="
              w-full
              h-full

              overflow-hidden

              transition-all
              duration-700
            "
          >
            {item.type === "image" ? (
              <div
                className="
                  w-full
                  h-full

                  bg-cover
                  bg-center

                  transition-all
                  duration-700
                "
                style={{
                  backgroundImage: `url(${item.src})`,
                }}
              />
            ) : (
              <div
                className="
                  w-full
                  h-full

                  bg-[#00154b]

                  flex
                  items-center
                  justify-center

                  p-6

                  transition-all
                  duration-700
                "
              >
                <img
                  src={item.src}
                  alt="logo"
                  className="
                    max-w-[120px]

                    object-contain
                  "
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>

   <section
  className="
    w-full

    bg-[white]

    py-8
    lg:py-8
    mt-[40px]
    md:mt-[20px]
    md:ml-[40px]
  "
>
  <div
    className="
      max-w-[1400px]

      mx-auto

      px-6
      sm:px-10
      lg:px-20

      grid
      grid-cols-1
      lg:grid-cols-2

      gap-10
      lg:gap-16

      items-center
    "
  >
    {/* RIGHT CONTENT */}
    <div className="order-1 lg:order-2">
      <p
        className="
          text-[#2b1b1b]
          md:text-[17px]

          uppercase

          tracking-[0.5px]

          text-[14px]
          font-[800]
          lg:text-[15px]

        "
      >
        DailyPay In Action
      </p>

      <h2
  className="
    mt-5
    lg:mt-7

    text-[#1a0000]

    text-[36px]
    sm:text-[56px]
    md:text-[36px]
    md:font-sans
    lg:text-[42px]
    font-[900]

    lg:font-sans

    tracking-[-4px]
    lg:tracking-[0px]
    md:tracking-normal

    leading-[0.75]
    md:leading-[1]
    md:w-[280px]

  "
>
  Hear From Our Clients
</h2>

     <p
  className="
    mt-6
    lg:mt-6

    text-[#2a0000]

    text-[19px]
    sm:text-[30px]
    md:text-[24px]
    lg:text-[28px]

    lg:font-light

    leading-[1.2]
    md:leading-[1.1]
    lg:leading-[1.2]

    tracking-[-0.7px]

    font-serif

    max-w-[360px]
    md:max-w-[400px]
    lg:max-w-[550px]
  "
>
  “In terms of measuring the success of
  DailyPay or other benefits, really <br className=" lg:hidden md:hidden "/> what  we
  look at is take rate. The take <br className=" lg:hidden md:hidden "/> rate for
  DailyPay is magnitudes above any other
  benefit that we offer.”
</p>

      <div className="mt-4 lg:mt-6">
        <h4
          className="
            text-[17px]
            lg:text-[16px]

            font-bold

            text-[#1a0000]
          "
        >
          John Shagoury
        </h4>

        <p
          className="
            mt-2

            text-[14px]
            lg:text-[16px]
            font-semibold

            text-[#2b1b1b]
          "
        >
          President & COO | Intelycare
        </p>

        <img
          src={intelycareLogo}
          alt="IntelyCare"
          className="
            mt-5
            lg:mt-4

            w-[150px]
            lg:w-[180px]

            object-contain
          "
        />
      </div>
    </div>

    {/* VIDEO */}
<div
  className="
    order-2
    lg:order-1

    relative

    mt-8
    lg:mt-0
   
    w-full
    lg:w-[600px]
    md:w-[350px]
    md:h-[250px]
    md:rounded-t-[28px]


    overflow-hidden

  "
>
  <iframe
    src="https://iframe.mediadelivery.net/embed/208304/2cf6a74c-32c2-49cf-b2be-2f8af15cf606?autoplay=true&loop=true&muted=true&preload=true&responsive=true"
    loading="lazy"
    className="
      w-full

      h-[260px]
      sm:h-[500px]
      md:h-[250px]
      lg:h-[350px]

      lg:w-[585px]

      border-0
      md:border-2

    "
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>
  </div>
</section>

<section
  className="
    w-full

    bg-[white]

    py-20
    sm:py-24
    lg:py-10
  "
>
  <div
    className="
      max-w-[1400px]

      mx-auto

      px-6
      sm:px-10
      lg:px-15
    "
  >
    <h2
      className="
      lg:mt-[90px]
      
        text-[#420303]

        text-[32px]
        sm:text-[48px]
        lg:text-[44px]

        leading-[0.95]

        font-serif
        font-light
      "
    >
      Client success stories
    </h2>

    <p
      className="
        mt-10
        lg:mt-6

        max-w-[950px]

        text-[#111111]

        text-[15px]
        sm:text-[26px]
        lg:text-[16px]

        leading-[1.5]
      "
    >
      Don't take our word for it. See how companies
      like yours are achieving measurable results
      with  DailyPay — from reducing turnover to
      boosting employee engagement.
    </p>

    <button
      className="
        mt-10
        lg:mt-3

        text-[#1a0000]

        text-[24px]
        lg:text-[16px]

        font-bold

        flex
        items-center

        gap-3

        hover:gap-5

        transition-all
        duration-300
      "
    >
      Read all customer stories

      <span className="text-[30px]">
        →
      </span>
    </button>
  </div>
</section>
<CaseStudy />
<Testimonials />
<CompanyForm />
<Footer />
    </>
  );
}